/* eslint-disable import/no-cycle */
import useJwt from '@/auth/jwt/useJwt'
import { dashboardPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt
// const reportingUrl = 'https://sandbox-reporting.udara360.io/api'
export default {
  getCustomersByGender: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/customersByGender')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountsByStatus: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/accountsByStatus')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanSummaries: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/loanSummary')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRecentActivities: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/recentActivities')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCurrentLoggedInUsers: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/userLoginDate')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountTypeByDeposit: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/depositByAccountType')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPendingLoanRequest: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/pendingLoanDisbursement')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNplRatio: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/nplRatio')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanPortfolioSummary: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/loanPortfolioRiskSummary')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerGrowthAnalytics: async (context, { year }) => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get(`/reporting/api/Dashboard/v1/monthlyCustomerGrowth?Year=${year}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPARFormulaeSummaryAction: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/PARFormulaeSummary')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTopDepositors: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/GetTopDepositors')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTopRiskExposures: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/GetTopRiskExposures')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDashboardRegulatoryCompliance: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/GetDashboardRegulatoryCompliance')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAssetQualityRation: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/GetAssetQualityRatio')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSavingsRatio: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/GetDashboardSavingsRatio')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getMicroLoanAssetRatio: async () => {
    try {
      useJwt.setPermission(dashboardPermissions.VIEW_BASIC_DASHBOARD)
      const response = await axiosIns.get('/reporting/api/Dashboard/v1/GetDashboardMicroLoanAssetRatio')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCreditLimitOverview: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/reporting/api/PFIDashboard/v1/GetDashboardOverview')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getQuickLinks: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/reporting/api/PFIDashboard/v1/GetPFIQuickLinks')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
